import data from "./tvData.json";
export const productsRange = {
  Televisions: [...data],
  Mattresses: [],
};
